module.exports = __webpack_public_path__ + "img/success.747f59a5.png";